// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ygnh9","right":"Footer_right__ob0l4","buttons":"Footer_buttons__2WJyk"};